export const MONITOR_TYPE = {
  1: '基础服务监控',
  2: '服务风险监控'
}